import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { BaseApiService } from '../../../Services/base-api.service';



@Component({
  selector: 'app-add-contact',
  templateUrl: './add-contact.component.html',
  styleUrls: ['./add-contact.component.css'],
  encapsulation:ViewEncapsulation.ShadowDom,standalone:false
})
export class AddContactComponent  implements OnInit{
  form!: FormGroup;

  imageUrl: string = '';
  loading:boolean=false;

  constructor
  (
  private repository:BaseApiService,
  private http: HttpClient,
  private messageService:MessageService,
  )
{


}

  onSubmit() {
    this.loading=true
    if (this.form.valid) {

      const formValues = this.form.value;
      this.repository.create("ContactPage/AddContact", formValues).subscribe((response) => {
        this.loading=false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: "Your Message Recieved! We will get back to you Soon.." });
        this.form.reset();
      }
      ,(error)=>
      {
        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
      );
    } else {
         this.loading=false;
    }


  }



 ngOnInit(): void {

  this.form = new FormGroup({
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required,Validators.email]),
    description: new FormControl('', [Validators.required])
  });

 }






}
